import React from 'react';
import styles from "./styles.module.scss";

type CardVariant = 'blå' | 'grønn' | 'gul' | 'grå' | 'default';

type ApplicationCardProps = {
    title: string;
    variant?: CardVariant;
    children?: React.ReactNode;
}

const ApplicationCard = ({ title, variant = 'default', children }: ApplicationCardProps) => {
    const getContainerClass = (variant: CardVariant) => {
        switch (variant) {
            case 'blå':
                return styles.blåTema;
            case 'grønn':
                return styles.grønnTema;
            case 'grå':
                return styles.gråTema;
            case 'gul':
                return styles.gulTema;
            default:
                return styles.container;
        }
    };

    return (
        <div className={getContainerClass(variant)}>
            <div className={styles.titleRow}>
                <span className={"pkt-txt-20"}>{title}</span>
            </div>
            <div className={styles.detailsRow}>
                {children}
            </div>
        </div>
    );
};

export default ApplicationCard;